import script from "./MedicationPharmacyTabPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MedicationPharmacyTabPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MedicationPharmacyTabPanel.vue?vue&type=style&index=0&id=79468f56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79468f56"]])

export default __exports__